export default function () {
  return new window.R.ui.Stream({ grid: true });
}
